import { TreeGrid, Freeze as TreeGridFreeze } from '@syncfusion/ej2-treegrid';
/**
 * Column freeze module
 */
export class Freeze {
    constructor(gantt) {
        this.parent = gantt;
        TreeGrid.Inject(TreeGridFreeze);
        this.parent.treeGrid.frozenColumns = this.parent.frozenColumns;
    }
    /**
     * Get module name
     *
     * @returns {string} .
     */
    getModuleName() {
        return 'freeze';
    }
    /**
     * To destroy freeze module.
     *
     * @returns {void} .
     * @private
     */
    destroy() {
        // Destroy Method
    }
}
